var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconWatched = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6BA543;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.5,
    cy: 7.5,
    r: 7.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.42,10.95c-0.15,0-0.29-0.06-0.38-0.18L4.1,8.48c-0.18-0.21-0.15-0.52,0.06-0.7 c0.21-0.18,0.52-0.15,0.7,0.06l1.52,1.79l3.72-5.37c0.16-0.23,0.47-0.28,0.69-0.13c0.23,0.16,0.28,0.47,0.12,0.69l-4.09,5.9 c-0.09,0.13-0.23,0.21-0.39,0.21C6.44,10.95,6.43,10.95,6.42,10.95z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWatched, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Watched.4e258ebb.svg";
export { ForwardRef as ReactComponent };